import React, { useState } from "react";
import ClientHeader from "../../client-header/components/index";
import ClientFooter from "../../client-footer/components/index";

const ClientFaqs = () => {
  const [openFaq, setOpenFaq] = useState(0);

  const faqs = [
    {
      question: "What is the primary mission of The Just Generation Foundation?",
      answer: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
    },
    {
      question: "How can I get involved or volunteer?",
      answer: "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
    },
    {
      question: "Are donations tax-deductible?",
      answer: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo."
    },
    {
      question: "What programs do you currently offer for children?",
      answer: "Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet."
    },
    {
      question: "How do I apply for assistance or resources?",
      answer: "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident."
    }
  ];

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? -1 : index);
  };

  return (
    <>
      <ClientHeader />
      <main className="overflow-hidden">
        
        {/* HERO SECTION */}
        <section className="homepad-about py-5" style={{ backgroundColor: "#f4f7f6" }}>
          <div className="container py-lg-5 text-center">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <h6 className="text-success font-weight-bold text-uppercase mb-3" style={{ letterSpacing: "2px" }}>
                  Support Center
                </h6>
                <h1 className="font-weight-bold montserrat text-primary mb-4" style={{ fontSize: "3.5rem", lineHeight: "1.1" }}>
                  Frequently Asked <span className="text-success">Questions.</span>
                </h1>
                <p className="font-size-18 text-muted line-hight-3 mb-0">
                  Find answers to common questions about our programs, donations, and how you can support our mission.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ ACCORDION SECTION */}
        <section className="py-5 my-5">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-9">
                {faqs.map((faq, index) => (
                  <div key={index} className="card border-0 shadow-sm rounded-4 mb-3 overflow-hidden">
                    <div 
                      className="card-header bg-white border-0 p-4 cursor-pointer d-flex justify-content-between align-items-center"
                      onClick={() => toggleFaq(index)}
                      style={{ cursor: "pointer", transition: "background-color 0.2s" }}
                    >
                      <h5 className={`font-weight-bold mb-0 font-size-18 ${openFaq === index ? 'text-success' : 'text-primary'}`}>
                        {faq.question}
                      </h5>
                      <svg 
                        xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" 
                        stroke={openFaq === index ? "#198754" : "#083B5C"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                        style={{ transform: openFaq === index ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.3s ease" }}
                      >
                        <polyline points="6 9 12 15 18 9"></polyline>
                      </svg>
                    </div>
                    <div 
                      className="card-body px-4 pb-4 pt-0 text-muted font-size-16 line-hight-3"
                      style={{ display: openFaq === index ? "block" : "none" }}
                    >
                      <hr className="mt-0 mb-3" style={{ opacity: 0.1 }} />
                      {faq.answer}
                    </div>
                  </div>
                ))}

                {/* Still have questions CTA */}
                <div className="text-center mt-5 pt-4">
                  <h4 className="font-weight-bold text-primary mb-3">Still have questions?</h4>
                  <p className="text-muted mb-4">Can't find the answer you're looking for? Please chat to our friendly team.</p>
                  <a href="/contact" className="btn btn-success btn-lg font-weight-bold px-5 py-3 rounded-3">
                    Contact Us
                  </a>
                </div>

              </div>
            </div>
          </div>
        </section>

      </main>
      <ClientFooter />
    </>
  );
};

export default ClientFaqs;